import * as types from '../mutation-types'
import configList from '@/components/editor/config'
import coverImg from '@/assets/images/cover/02shangwu/2.jpg'
import merge from 'loadsh/merge'
/* eslint-disable-next-line */
import { getSurveyInfo, getLanguage, getLanguageList, getStyleById } from '@/service/question'
import { getSurveyAndAnswer, getSurveySetting } from '@/service/survey'
import util from '@/tools/commonUtil'
import Answer from '@/components/editor/answer'
import cloneDeep from '@/third/CloneDeep'
import groupby from '@/third/Groupby'
import varType from '@/tools/varType'
// import surveyData from '@/surveyData_origin.js'

// 所有题型对应类的集合
const CONFIGLIST_MAPP = {}
configList.forEach(config => {
  const elementType = config.elementType
  var type = util.convertQuType(config) || elementType
  CONFIGLIST_MAPP[type] = config
})

const answerTypeList = [
  {
    value: '01',
    label: '等于'
  },
  {
    value: '02',
    label: '小于'
  },
  {
    value: '03',
    label: '小于等于'
  },
  {
    value: '04',
    label: '大于'
  },
  {
    value: '05',
    label: '大于等于'
  }
]

const DEFAULT_COLOR = '#38ADAB'

const state = {
  setting: {}, // 问卷设定

  surveyMainId: 0, // 主问卷ID
  surveyId: '', // 问卷编号
  groupList: [], // 题组
  toUrl: '',
  questionList: [],
  allQuestionList: [],
  answerTypeList,
  answerStatus: '', // 1不处理(继续答卷) 2 答卷完成，3 答卷被甄别
  isComplete: '',
  lang: sessionStorage.getItem('survey-lang') ? sessionStorage.getItem('survey-lang') : 'origin', // 当前语言
  surveyLanguage: '', // 问卷所有语言
  surveyLanguages: [], // 问卷语言下拉
  langMap: {}, // 多语言缓存
  answerStyleConfig: {
    // 风格
    fengge: {
      styleType: 'xiaoyuan',
      color: DEFAULT_COLOR,
      imgUrl: ''
    },
    // 封面
    fengmian: {
      color: DEFAULT_COLOR, // 封面的颜色
      imgType: '01', // 01发布图片 02 选择颜色
      imgUrl: coverImg,
      showLogoInd: '1', // 显示logo
      logoUrl: '',
      logoPositionType: '03', // 01左对齐 02居中 03右对齐
      showFengmian: '0', // 封面
      // 标题
      showTitleInd: '1', // 显示标题
      titlePositionType: '03', // 01上 02中 03下
      titleFontSize: 16, // 文字大小
      titleColor: DEFAULT_COLOR, // 字体颜色
      titleBoldInd: '', // 加粗
      titleFontItalicInd: '', // 倾斜
      titleUnderLineInd: '', // 下划线
      titleAlignType: '01', // 01左对齐 02居中 03右对齐
      // 开始方式
      startType: '02', // 01开始按钮 02 向上滑动
      btnBgColor: '#4D83CF', // 按钮底色
      btnTextColor: '#616161', // 按钮文字颜色
      btnText: '' // 按钮文字
    },
    // 问题页
    question: {
      // 页眉设置
      showYeMeiInd: '1', // 显示页眉
      yemeiType: '03', // 01文字 02单图 03多图
      yemeiText: '', // 文字内容
      yemeiFontSize: 24, // 文字大小
      yemeiColor: '', // 字体颜色
      yemeiBoldInd: '', // 加粗
      yemeiFontItalicInd: '', // 倾斜
      yemeiUnderLineInd: '', // 下划线
      yemeiAlignType: '03', // 01左对齐 02居中 03右对齐
      yemeiBgColor: DEFAULT_COLOR, // 背景色
      // 欢迎语
      welcomes: '', // 欢迎语
      // 背景设置
      showBgInd: '1', // 显示背景
      bgType: '01', // 01发布图片 02 选择颜色
      bgImgUrl: '', // 背景图片
      bgColor: '', // 背景颜色
      manyInterval: 10
    },
    // 结束页
    endPage: {
      // Logo设置
      showLogoInd: '1', // 显示logo
      logoUrl: '',
      logoPositionType: '03', // 01左对齐 02居中 03右对齐
      // 背景设置
      showBgInd: '1', // 显示背景
      bgType: '01', // 01发布图片 02 选择颜色
      bgImgUrl: '', // 背景图片
      bgColor: '' // 背景颜色
    },
    // 字体设置
    font: {
      quFontSize: 24, // 文字大小
      quColor: '', // 字体颜色
      quBoldInd: '', // 加粗
      quFontItalicInd: '', // 倾斜
      quUnderLineInd: '', // 下划线
      welcomeFontSize: 24, // 文字大小
      welcomeColor: '', // 字体颜色
      welcomeBoldInd: '', // 加粗
      welcomeFontItalicInd: '', // 倾斜
      welcomeUnderLineInd: '', // 下划线
      descFontSize: 24, // 文字大小
      descColor: '', // 字体颜色
      descBoldInd: '', // 加粗
      descFontItalicInd: '', // 倾斜
      descUnderLineInd: '', // 下划线
      optionFontSize: 24, // 文字大小
      optionColor: '', // 字体颜色
      optionBoldInd: '', // 加粗
      optionFontItalicInd: '', // 倾斜
      optionUnderLineInd: '', // 下划线
      endFontSize: 24, // 文字大小
      endColor: '', // 字体颜色
      endBoldInd: '', // 加粗
      endFontItalicInd: '', // 倾斜
      endUnderLineInd: '' // 下划线
    },
    // 按钮设置
    button: {
      startText: '', // 开始按钮文字
      sbmitText: '提交', // 提交按钮文字
      btnColor: DEFAULT_COLOR // 按钮颜色
    },
    // 显示设置
    display: {
      showTitleInd: '1', // 显示标题
      showWelComeInd: '1', // 显示欢迎语
      titleSize: '01', // 大
      showPreBtnInd: '1' // 显示上一页按钮
    },
    // 隐藏设置
    hidden: {
      hidePreBtnInd: '1', // 隐藏上一页
      hideQuNumInd: '1', // 隐藏题目序号
      hideBar: '1' // 多页时隐藏进度条
    },
    lang: {
      // 封面
      startText: '开始',
      slideText: '上滑开始',
      // 问题页面
      lastStep: '上一页',
      nextStep: '下一页',
      sbmitText: '提交',
      // 问卷答案提示
      tipAnswerNull: '答案不能为空！',
      tipScoreNull: '请给本题打分！',
      tipRateNull: '还有有子问题未回答！',
      minRequired: '请至少填写${n}个字！',
      maxRequired: '请至多填写${n}个字！',
      minAnswerNum: '请至少勾选${n}个答案！',
      maxAnswerNum: '请最多勾选${n}个答案！',
      // 题型
      RadioBox: '单选',
      RadioBoxGroup: '矩阵单选',
      CheckBox: '多选',
      CheckBoxGroup: '矩阵多选',
      FillBlankBox: '完形填空题',
      TitleBox: '开放题'
    },
    // 通用设置
    common: {
      // 语言
      showLangSelector: '0', // 显示语言选择
      showQuNumInd: '1', // 显示题目序号
      showQuestionType: '1' // 显示题型
    },
    // 对答式分享设置
    bot: {
      headImg: '', // 头像
      headName: '' // 头像名称
    }
  },
  surveyStyle: { // 外观设置
    // 问卷id
    surveyId: '',
    // 风格
    surveyStyle: '',
    // 顔色
    surveyColor: '',
    // 图片
    surverImage: '',
    // 外观封面
    surveyCover: '',
    // 外观封面名称
    surveyCoverName: '',
    // 外观页眉设置
    surveyHeader: '',
    // 外观页眉名称
    surveyHeaderName: '',
    // 外观页脚设置
    surveyFooter: '',
    // 外观页脚名称
    surveyFooterName: '',
    // 外观logo位置设置
    surveyLogoPosition: '',
    // 外观logo設置名稱
    surveyLogoSetupName: '',
    // 外观log设置
    surveyLogoSetup: '',
    // 外观主题设置
    surveyThemes: '',
    // 外观按钮文章设置
    surveyBtnSetup: '',
    // 外观隐藏标题
    surveyHideTitle: '',
    // 外观隐藏反应语
    surveyHideWelcome: '',
    // 外观隐藏上一页按钮
    surveyHidePreBtn: '',
    // 外观隐藏题目序号
    surveyHideQuNum: '',
    // 外观隐藏进度
    surveyHideProcess: '',
    // 回答提示
    surveyHideAnTip: ''
  },
  surveyInfo: {
    surveyName: '',
    surveyType: '',
    surveyCategory: '',
    surveyBrand: '',
    surveyCycle: '',
    surveyLanguage: [],
    surveyLableIds: '',
    surveyNote: '',
    groupList: [],
    type: '',
    shareType: '1', // 1公开2私有3公开+私有
    surveyState: '0', // 问卷状态  0默认设计状态  1发布2结束
    isEndYes: '', // 结束页-是否选中
    endYesText: '', // 完成标题
    endYesDesc: '', // 完成描述
    endYesImg: '', // 完成图片
    isEndNo: '', // 结束页-是否选中
    endNoText: '', // 未完成标题
    endNoDesc: '', // 未完成标题
    endNoImg: '', // 未完成图片,
    // 选项随机排列  1随机排列 0不随机排列
    randOrder: '0',
    // 随机排序ids(1,2,3)
    randIds: [],
    invalidContent: '', // 无效问卷展示内容
    ifDeliveryLinkExpired: false // 投放链接是否有效
  },
  surveyAnswer: {}, // 答题数据
  // 主问卷信息
  surveyMain: {
    id: 0,
    surveyStatus: 0
  },
  // 问卷语言
  surveyInfoLang: {
    // 问卷名称
    surveyName: '',
    // 欢迎语
    surveyNote: '',
    // 问卷完成提示
    endYesDesc: '',
    // 结束语页面内容
    endYesContent: '',
    // 失效页面内容
    invalidContent: '',
    // 页眉文字内容
    yemeiText: ''
  },
  status: '1', // 问卷状态0未完成1完成2被甄别3配额满
  currentPage: 0, // 当前答题页
  userPage: 0, // 客户答题页面
  windowType: 'mobile', // pc or mobile
  userInfo: '', // 用户信息,
  custQuote: {},
}

const getters = {
  setting: (state) => state.setting,
  groupList: state => {
    const groupList = state.surveyInfo.groupList
    return groupList
  },
  allQuestionList: state => {
    const allQuestionList = state.allQuestionList
    return allQuestionList
  }
}

const getValueByType = (value, valueType) => {
  /* if (util.isNull(value)) {
    return value
  } */
  if (valueType === 'array') {
    return value || []
  } else if (valueType === 'object') {
  } else if (valueType === 'string') {
    return !value ? '' : value.join('')
  } else if (valueType === 'null') {
    return util.isNull(value) ? null : value.join('') * 1
  }
}

// 设置子问题答案
const setItemAnswerValue = (item, valueType, valueMap, otherAnswerMap) => {
  const id = item.id
  item.value = getValueByType(valueMap[id], valueType)
  item.otherAnswer = otherAnswerMap[id]
}

// 设置问题答案
const setQuestionValue = (config, valueType, valueMap, otherAnswerMap) => {
  const descList = config.descList
  if (descList && descList.length) {
    descList.forEach(item => {
      setItemAnswerValue(item, valueType, valueMap, otherAnswerMap)
    })
  } else {
    setItemAnswerValue(config, valueType, valueMap, otherAnswerMap)
  }
}

// merge处理问题的数据
const assignCommonData = (config, qu) => {
  const { belongId, id, quTitle, groupId, orderById, isRequired, randOrder,
    imgUrl, imgName, quBeforLogics, quLogics, quoteQuId, page, visibility,
    quNote, hv, minAnswerNum, maxAnswerNum, optionRuleType, exclusiveItemsId,
    mutualItemsId, udfOptionInd, answerRules, randType, shortLabel, screenCode, 
    mediaQuType, ifOpenGroup, quBeforLogicsNew, placeholder, quLogicsNew, quContentLogics, quCode } = qu
  let { answerConfig, optionGroupList } = qu
  config.belongId = belongId
  config.id = id
  config.originTitle = quTitle
  config.title = quTitle
  config.groupId = groupId
  config.orderById = orderById
  config.isRequired = isRequired
  config.randOrder = randOrder
  config.randType = randType || '2'
  config.imgUrl = imgUrl
  config.imgName = imgName
  config.answerRules = answerRules || []
  config.quBeforLogics = quBeforLogics || []
  config.quLogics = quLogics || []
  config.quoteQuId = quoteQuId
  config.page = page
  // config.visibility = visibility || 1
  config.quNote = quNote || '' // 题目内容
  config.hv = hv // 1图上文下 2图下文上
  config.minAnswerNum = minAnswerNum
  config.maxAnswerNum = maxAnswerNum
  config.optionRuleType = optionRuleType
  config.exclusiveItemsId = exclusiveItemsId
  config.mutualItemsId = mutualItemsId
  config.udfOptionInd = !!udfOptionInd
  config.shortLabel = shortLabel
  config.screenCode = screenCode
  config.mediaQuType = mediaQuType
  config.quBeforLogicsNew = quBeforLogicsNew // 新的提前逻辑
  config.quLogicsNew = quLogicsNew // 新的答题逻辑
  config.quContentLogics = quContentLogics || [] // 内容逻辑
  config.currentLang = state.lang // 当前语言
  config.quCode = quCode // 题号
  config.placeholder = placeholder // 占位提示内容
  config.groupVisibility = true // 题组是否隐藏
  config.quVisibility = true // 题目是否隐藏
  config.visibility = visibility //  题目显示逻辑
  if (ifOpenGroup) {
    config.ifOpenGroup = ifOpenGroup
  }

  // 处理题组
  if (optionGroupList && typeof optionGroupList === 'string') {
    optionGroupList = JSON.parse(optionGroupList)
  }
  config.optionGroupList = optionGroupList || []
  // 处理题组的原始标题
  if (config.optionGroupList && config.optionGroupList.length > 0) {
    config.optionGroupList.forEach(item => {
      item.originTitle = item.optionGroupName
    })
  }

  /**
   * 处理答案逻辑，保持其与“内容逻辑的subFilter”、“题前逻辑（显示逻辑）的subFilter”保持一致
   * TODO：由于答案逻辑针对的是问题自身，所以原先没有用另外的字段记录问题id、子问题id等（与其他逻辑条件不一致）
   * 考虑修改原始数据的影响，暂时在答卷项目中处理数据
   */
  if (config.quLogicsNew && config.quLogicsNew.length > 0) {
    config.quLogicsNew.forEach(quLogic => {
      if (quLogic.logics && quLogic.logics.subFilter && quLogic.logics.subFilter.length > 0) {
        quLogic.logics.subFilter.forEach(subFilter => {
          if (subFilter.list && subFilter.list.length > 0) {
            subFilter.list.forEach(item => {
              item.anQuId = item.quId
              item.anQuType = item.quType
              item.anSubQuId = item.subQuId
              // item.anQuItemId = item.anQuItemId（本身存储就是anQuItemId）
            })
          }
        })
      }
    })
  }

  // 获取问题配置
  if (answerConfig && typeof answerConfig === 'string') {
    answerConfig = JSON.parse(answerConfig)
  }
  // 处理问题配置
  if (answerConfig) {
    // 旧数据没有isShow
    if (!answerConfig.isShow) {
      answerConfig.isShow = '0'
    }
    // 旧数据没有fixLastOptionIndNum
    if (!answerConfig.fixLastOptionIndNum) {
      answerConfig.fixLastOptionIndNum = 1
    }
  }
  config.answerConfig = answerConfig || {
    requireInd: '1', // 必答
    otherRequireInd: '1', // 其他请注明必答
    optRandType: '01', // 选项顺序 01顺序 02随机 03循环
    optLayout: '01', // 选项顺序 01顺序 02随机 03循环
    childRandType: '01', // 分组/子问题顺序
    fixLastOptionInd: '0', // 最后一个选项固定位置
    fixLastOptionIndNum: 1, // 最后选项固定位置个数
    optionExInd: '0', // 选项互斥开关
    optionExType: '', // 选项互斥 01排他 02 互斥
    optionExItems: [], // 互斥选项
    answerLimitInd: '0', // 答题个数限制
    minAnswerNum: '', // 至少回答
    maxAnswerNum: '', // 最多回答
    limitRangeInd: '0', // 限制范围
    paramInt01: '', // 最大值
    paramInt02: '', // 最小值
    scoreNumType: '', // 支持类型
    answerValidInd: '0', // 答案验证
    answerRangeType: '', // 答案范围 01 等于 02 小于
    rangeTargetId: '', // 范围满足题目
    uploadType: '01', // 上传方式
    answerOpenInd: '', // 设置开放题
    answerOpenTitle: '', // 开放题
    uniqueInd: '0', // 邮箱排重
    validInd: '1', // 邮箱验证
    timeType: '01', // 时间类型
    validateRuleType: '0', // 验证规则 0:不限  1:中文  2:字母  3:网址  4:自定义
    isShowVotingScore: '0', // 0:不显示投票结果，1:显示投票结果
    maxUploadFileCount: 1, // 最大上传文件个数,默认1个
    maxUploadFileSize: 5, // 最大上传文件大小,默认5M
    uploadFileTypeList: '', // 文件可上传的类型列表，例如'doc, execl'
    validateRuleValue: '', // 验证正则
    satisfactionType: 1, // 满意度-样式类型 1:星型  2:爱心  3:点赞  4:笑脸  5:选项
    satisfactionNumber: 5, // 满意度-个数 min:2  max:10
    satisfactionCommentLabel: '0', // 满意度-评价标签 0:关  1:开
    satisfactionCommentInput: '0', // 满意度-写评价 0:关  1:开
    scoreVerification: '0', // 评分校验 0:关  1:开
    scoreRepeatNum: 1, // 重复评分个数
    scoreRepeatTips: '', // 重复提示文本
    fixedOptions: [], // 固定选项
    fixedChildren: [], // 固定分组/子问题
    phoneCheck: '0', // 手机验证
    phonePrefix: '', // 手机前缀
    answerMinInd: '0', // 最短作答时间开关
    answerMinTime: '', // 最短作答时间
    answerMinTips: '' // 最短文字提示
  }

  // 处理题目默认隐藏设置（此设置根据后台的配置，固定不变）
  if (config.answerConfig && config.answerConfig.isShow === '1') {
    config.quVisibility = false
  }
}

// merge处理已答问题答案的数据
const assignAnswerValue = (config, qu) => {
  const answerList = qu.answerList
  if (!answerList || !answerList.length) {
    return
  }
  const valueMap = {}
  const otherAnswerMap = {}
  const extendsDataMap = {}
  answerList.forEach(item => {
    const { descId, answer, otherAnswer, extendsData } = item
    if (!valueMap[descId]) {
      valueMap[descId] = []
    }
    otherAnswerMap[descId] = otherAnswer
    extendsDataMap[descId] = extendsData
    valueMap[descId].push(answer)
  })
  const answer = Answer[config.elementType]
  if (answer && answer.setAnswer) {
    answer.setAnswer.bind(config)(qu, valueMap, otherAnswerMap, extendsDataMap, answerList)
  } else {
    const descList = config.descList
    let valueType
    if (descList && descList.length) {
      valueType = varType(descList[0].value)
    } else {
      valueType = varType(config.value)
    }
    setQuestionValue(config, valueType, valueMap, otherAnswerMap)
  }
}

// TODO: 题组顺序随机？ - by wangze
const randomGroup = (orgArr, filter) => {
  const randomItems = orgArr.filter(filter).sort(_ => 0.5 - Math.random())
  return orgArr.map(item => filter(item) ? randomItems.pop() : item)
}

/**
 * 针对问题组，问题组内的问题进行预处理
 * --预处理后缓存所有问题
 * @param {*} groupList
 * @param {*} queryType
 */
const handleGroupList = (groupList, queryType) => {
  // 处理group，问题列表挂载到state
  state.allQuestionList = groupList.reduce((groupQuestionList, group) => {
    const questionList = group.questionList
    const questions = []
    if (questionList) {
      questionList.forEach(qu => {
        // clone对应问题的类
        const config = cloneDeep(CONFIGLIST_MAPP[qu.quType])

        // 合并处理问题的数据
        assignCommonData(config, qu)
        config.queryType = queryType

        // 重新生成选项/子问题列表（+排序）
        // 处理子问题/选项的原始标题
        config.saveCb && config.saveCb(qu)

        // 处理选项显示/隐藏
        const optionHidden = config.answerConfig.optionHidden
        const optionHiddenItems = config.answerConfig.optionHiddenItems
        if (config.optionList && config.optionList.length > 0) {
          config.optionList.forEach(item => {
            item.ifHidden = 2
            if (optionHidden === '1' && optionHiddenItems.indexOf(item.id) !== -1) {
              item.ifHidden = 1
            }
            item.displayTitle = ''
          })
        }

        if (config.descList && config.descList.length > 0) {
          config.descList.forEach(item => {
            // displayTitle转为响应式熟悉
            item.displayTitle = ''
          })
        }
        
        // TODO: 对答式问卷新增字段
        // config.avatar = 'avatar.png',
        config.source = 'service'

        config.displayTitle = ''
        config.displayElementDesc = ''
        config.displayPlaceholder = ''
        questions.push(config)

        // 矩阵题处理，子问题拆分为多个题目（与其他题目同一级别）子问题沿用主问题的配置
        if (queryType === 'answer' && /^RadioBoxGroup|CheckBoxGroup$/.test(config.elementType)) {
          const { randOrder, randType } = config
          // 拆解矩阵题
          /* RateGroupBox */
          const descList = cloneDeep(config.descList)
          config.descIndex = 0
          assignAnswerValue(config, qu)
 
          descList.filter((item, index) => index > 0).forEach((item, index) => {
            const descConfig = cloneDeep(config)
            item.displayTitle = ''
            descConfig.isVirtualPage = true // 不会分页
            descConfig.descList = cloneDeep(descList)
            descConfig.descIndex = index + 1
            if (randOrder === '1' && /1|2/.test(randType)) {
              descConfig.optionList = util.randomSort(descConfig.optionList).map(option => {
                option.optionTitle = ''
                option.displayTitle = ''
                return option
              })
            }
            descConfig.displayTitle = ''
            descConfig.displayElementDesc = ''
            descConfig.displayPlaceholder = ''
            questions.push(descConfig)

            assignAnswerValue(descConfig, qu)
          })
        } else if (queryType === 'answer') {
          // 处理问题答案
          assignAnswerValue(config, qu)
        }
      })
    }
    group.status = 'view'
    group.questionList = questions

    return groupQuestionList.concat(group.questionList)
  }, [])
}

const actions = {
  /**
   * 获取问卷详情和答题情况以及客户信息
   * --缓存客户属性、客户筛选条件合并、问卷详情、问卷基本信息
   * --所有问题组问题已答答案赋值、所有问题遍历缓存起来allQuestionList
   * --多语言配置 查询并缓存
   */
  async [types.QUERY_GROUPLIST] ({ commit, dispatch }, param) {
    const { surveyMainId } = state
    if (!surveyMainId) {
      return
    }

    // url参数
    let queryType = ''
    let messageId = ''
    const routerQuery = param.routerQuery
    if (param) {
      messageId = param.messageId
      queryType = param.queryType
    }
    let ret
    // 获取问卷详情和答案
    if (param.source === 'app') {
      ret = param.res
    } else {
      ret = await getSurveyAndAnswer({
        messageId,
        ...routerQuery,
        id: surveyMainId,
      })
    }

    // const ret = surveyData

    // 缓存客户属性
    let attrs = []
    if (ret.customerAttribute) {
      state.userInfo = ret.customerAttribute
      attrs = Object.keys(state.userInfo).map(attr => {
        return {
          attributeType: 'clientProperty',
          field: attr,
          fieldName: attr,
          value: state.userInfo[attr]
        }
      })

      // 客户筛选条件合并 - 投放时的客户筛选、问卷逻辑的客户筛选
      if (ret.custQuote) {
        state.custQuote = groupby(ret.custQuote, 'attributeType')
        if (state.custQuote.clientProperty) {
          state.custQuote.clientProperty.push(...attrs)
        }
      }
    }

    // 获取已有答卷信息
    const surveyAnswer = ret.surveyAnswer
    if (surveyAnswer) {
      state.userPage = surveyAnswer.userPage || 0
      state.status = surveyAnswer.status || '1'
      state.surveyAnswer = surveyAnswer
      commit(types.SET_ANSWER_STATUS, { answerStatus: surveyAnswer.answerStatus })
      // 此标识为此用户是否已经答过题了   1：完成  0：未完成
      commit(types.SET_IS_COMPLETE, { isComplete: surveyAnswer.isComplete ? surveyAnswer.isComplete : '' })
    }

    // 如果客户已经回答，设置当前页面为客户上次提交页面
    if (state.userPage > 0) {
      commit(types.SET_CURRENT_PAGE, state.userPage)
    }

    let retGroupList = ret.groupList

    // TODO: 离线app由前端排序，window._env_ === 'android'
    if (window._env_ === 'android' && ret.questionGroupSortType === 'RANDOM') {
      // 题组随机 
      retGroupList = util.randomSort(ret.groupList, {questionGroupFixed: ret.questionGroupFixed, answerConfig: {}}, 'group')
    } else if (window._env_ === 'android' && ret.questionGroupSortType === 'LOOP') {
      // 题组循环
      retGroupList = util.rotateSort(ret.groupList, {questionGroupFixed: ret.questionGroupFixed, answerConfig: {}}, 'group')
    }

    /**
     * 针对问题组，问题组内的问题进行预处理
     * --预处理后缓存所有问题
     */
    handleGroupList(retGroupList, queryType)

    // 缓存问卷详情、缓存问卷基本信息surveyMain
    commit(types.SYNC_SURVEY_INFO, ret)

    // 处理题组序号
    util.calcNum(retGroupList)

    // group信息挂载到state
    state.surveyInfo.groupList = retGroupList

    // 加载多语言配置
    state.surveyLanguage = ret.surveyLanguage
    state.surveyLanguages = ret.surveyLanguageNew.map(item => ({
      ...item,
      text: item.label
    }))
    // await dispatch(types.INIT_LANG_MAP)
  },

  // 获取多语言配置
  async [types.INIT_LANG_MAP] ({
    commit
  }, param) {
    const { surveyMainId } = state
    if (param && param.source === 'app') {
      commit(types.INIT_LANG_MAP, param.res)
    } else {
      return getLanguageList({
        surveyMainId,
        ...param
      }).then(ret => {
        commit(types.INIT_LANG_MAP, ret)
      })
    }
  },

  // 获取外观设置
  async [types.GET_STYLE] ({
    commit
  }, param) {
    const surveyId = state.surveyId
    if (!surveyId) {
      return
    }
    if (param && param.source === 'app') {
      commit(types.SYNC_STYLE, param.res)
    } else {
      return getStyleById({
        surveyId
      }).then(ret => {
        commit(types.SYNC_STYLE, ret)
      })
    }
  },

  // 获取问卷的设置
  async [types.GET_SETTING] ({
    commit
  }) {
    const surveyMainId = state.surveyMainId
    if (!surveyMainId) {
      return
    }
    return getSurveySetting(surveyMainId).then(ret => {
      commit(types.SYNC_SETTING, {data: ret})
    })
  },

  [types.SAVE_CONFIG] ({
    commit
  }, config) {
    config = cloneDeep(config)
    return config.saveFn().then(ret => {
      const data = ret
      assignCommonData(config, data)
      const saveCb = config.saveCb
      saveCb && saveCb.call(config, data)
    })
  },
}

const mutations = {
  /**
   * 缓存当前url参数及sessionStorage
   * --缓存当前url参数 surveyMainId(id) & windowType(type) & lang 
   * --缓存sessionStorage survey-lang(lang)
   */
  [types.INIT_CACHE_URL_PARAM] (state, param) {
    const surveyMainId = parseInt(param.id)
    state.surveyMainId = 0
    if (!isNaN(surveyMainId)) {
      state.surveyMainId = surveyMainId
    }

    let windowType = ''
    if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
      windowType = 'mobile'
    } else {
      windowType = 'pc'
    }
    state.windowType = param.type ? param.type : windowType
    // 问卷多语言
    if (param.lang) {
      state.lang = param.lang
      sessionStorage.setItem('survey-lang', param.lang)
    }
  },

  /**
   * 同步处理问卷详情和问卷基本信息
   * --缓存问卷详情、缓存问卷基本信息surveyMain
   */
  [types.SYNC_SURVEY_INFO] (state, res) {
    const data = cloneDeep(res || {})

    state.surveyId = data.id
    data.surveyId = data.id

    const randIds = data.randIds
    if (randIds) {
      data.randIds = randIds.split(',')
    } else {
      data.randIds = []
    }
    data.randOrder = data.randOrder || '0'
    state.toUrl = data.toUrl
    const groupList = state.surveyInfo.groupList
    data.surveyLanguage = util.str2arr(data.surveyLanguage)
    data.surveyNote = data.surveyNote || '欢迎参与！'

    data.groupList = groupList
    const shareType = data.shareType
    data.shareType = shareType === undefined ? '' : (shareType + '')
    const surveyState = data.surveyState
    data.surveyState = surveyState === undefined ? '0' : (surveyState + '')
    data.isToUrl = Boolean(data.isToUrl * 1)
    data.isEndYes = Boolean(data.isEndYes * 1)
    data.isEndNo = Boolean(data.isEndNo * 1)

    // 主问卷信息
    Object.assign(state.surveyMain, data.surveyMain)

    // 问卷版本信息
    Object.assign(state.surveyInfo, data)
  },

  // 缓存多语言配置
  [types.INIT_LANG_MAP] (state, data) {
    Object.assign(state.langMap, data)
  },

  // 缓存外观设置
  [types.SYNC_STYLE] (state, res) {
    const data = res || {}

    // 解析为Json对象
    const {answerStyleConfig, answerStylePcConfig, headImg, headName} = data
    let answerStyleConfigObj = {}
    let answerStylePcConfigObj = {}
    if (answerStyleConfig) {
      answerStyleConfigObj = JSON.parse(answerStyleConfig) || {}
    }
    if (answerStylePcConfig) {
      answerStylePcConfigObj = JSON.parse(answerStylePcConfig) || {}
    }

    // 覆盖默认设置
    // answerStyleConfig：移动端外观配置 + 通用配置
    // answerStylePcConfig：PC外观配置
    delete state.answerStyleConfig.question.yemeiImgAry
    state.answerStyleConfig = merge(state.answerStyleConfig, answerStyleConfigObj)
    // 判断如果是PC，再用PC外观配置覆盖
    if (state.windowType === 'pc') {
      // 删除通用的属性
      const delFieldArr = ['NpsBox', 'InfoBox', 'RateBox', 'CheckBox', 'RadioBox', 'TitleBox', 'maxRequired', 'minRequired', 'tipRateNull', 'FillBlankBox', 'RateGroupBox', 'maxAnswerNum', 'minAnswerNum', 'tipScoreNull', 'answerInvalid', 'tipAnswerNull', 'answerComplete', 'maxAnswerNumPhrase1', 'maxAnswerNumPhrase2', 'minAnswerNumPhrase1', 'minAnswerNumPhrase2']
      delFieldArr.forEach(item => {
        delete answerStylePcConfigObj.lang[item]
      })
      delete answerStylePcConfigObj.common
      delete state.answerStyleConfig.question.yemeiImgAry
      state.answerStyleConfig = merge(state.answerStyleConfig, answerStylePcConfigObj)
      // TODO PC和mobile暂时共用页眉
      // state.answerStyleConfig.question.yemeiText = answerStyleConfigObj.question && answerStyleConfigObj.question.yemeiText || ''
    }

    // 对答式分享设置
    state.answerStyleConfig.bot = {
      headImg, // 头像
      headName // 头像名称
    }

    // 处理问卷多语言配置(问卷信息 + 默认文字整合)
    Object.assign(state.surveyInfoLang, state.surveyInfo)
    state.surveyInfoLang.surveyName = state.surveyMain.surveyName
    // TODO style 和 lang解耦
    Object.assign(state.surveyInfoLang, state.answerStyleConfig.lang)
    state.surveyInfoLang.yemeiText = state.answerStyleConfig.question.yemeiText

    // 覆盖默认elementDesc
    for(const item in state.answerStyleConfig.lang) {
      const filterArr = state.allQuestionList.filter(qu => qu.elementType === item)
      if (filterArr.length) {
        for (let i=0; i<filterArr.length; i++) { 
          filterArr[i].elementDesc = state.answerStyleConfig.lang[item]
        }    
      }
    }
  },

  // 缓存问卷的设置
  [types.SYNC_SETTING] (state, {data}) {
    state.setting = data
  },

  [types.SET_CURRENT_PAGE] (state, page) {
    state.currentPage = page
  },

  [types.SET_ANSWER_STATUS] (state, param) {
    state.answerStatus = param.answerStatus
  },
  [types.SET_IS_COMPLETE] (state, param) {
    state.isComplete = param.isComplete
  },
  // 更新对答式问卷分享设置
  [types.BOT_SETTING] (state, param) {
    state.answerStyleConfig.bot = param
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}


// ——————————————————————————————————————没用代码 -by wangze——————————————————————————————————————

/* const SUB_QU_TYPE_MAP = {
  'phone1': 'ShouJiBox',
  'xingming': 'XingMingBox',
  'email': 'YouXiangBox',
  'idCard': 'ShenFenBox',
  'gender': 'XingBieBox',
  'age': 'NianLingBox',
  'birthday': 'ShengRiBox',
  'industry': 'HangYeBox',
  'workStatus': 'ZhiYeBox',
  'degree': 'XueLiBox',
  'address': 'ChengShiBox'
}

const convertSubQuType = config => {
  const { mediaQuType, screenCode } = config
  const code = mediaQuType || screenCode
  if (code) {
    return SUB_QU_TYPE_MAP[code]
  }
  return ''
} */

// const filterQuField = ['id', 'belongId', 'groupId', 'page', 'quBeforLogics', 'quLogics', 'quGroupLogics']
// const filterOptionField = ['quId', 'id', 'quoteQuId']
// const filterDescField = ['id', 'quId', 'quoteQuId']

// const filterField = (obj, fields) => {
//   if (obj) {
//     let filterObj = obj
//     if (!(obj instanceof Array)) {
//       filterObj = [filterObj]
//     }
//     filterObj.forEach(item => {
//       fields.forEach(field => {
//         delete item[field]
//       })
//     })
//   }
// }

/* eslint-disable-next-line */
// const filterCloneData = qu => {
//   filterField(qu, filterQuField)
//   filterField(qu.optionList, filterOptionField)
//   filterField(qu.descList, filterDescField)
// }

// ——————————————————————————————————————没用代码 -by wangze——————————————————————————————————————



// WEBPACK FOOTER //
// ./src/store/modules/Question.js